
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/dynata",
      function () {
        return require("private-next-pages/destinations/dynata.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/dynata"])
      });
    }
  